import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import Separator from '../../elements/separator/Separator';
import AffiliateVideo from '../../components/affiliate/AffiliateVideo';
import AffiliateCallToAction from '../../components/affiliate/AffiliateCallToAction';
import AffiliateDetails from '../../components/affiliate/AffiliateDetails';
import AffiliateHero from '../../components/community/AffiliateHero';
import AffiliateForm from '../../components/form/AffiliateForm';






const Community = () => {
    return (
        <>
            <SEO title="Affiliate" />
            <main className="page-wrapper">
                {/* <HeaderTopBar /> */}
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                <AffiliateHero />
                <div className="rn-service-area rn-section-gap ">
                    <div className='container'>
                        <AffiliateVideo />
                    </div>
                </div>     

                <div className="rn-service-area rn-section-gap ">
                    <div className='container'>
                        <AffiliateDetails />
                    </div>
                </div>    
                <div className="rn-service-area rn-section-gap " id="affiliateform">
                    <div className='container'>
                        <h3 className="text-center">📋 PWU Affiliate Program Application Form</h3>
                        <p className='text-center'>Please fill out the form below to apply as an official affiliate partner. Our team will review your application and respond within 72 hours.</p>
                    </div>
                    <br />
                    <AffiliateForm />
                </div>           

                <Separator />
                {/* Start Elements Area  Community Accordion*/}
                {/* <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                <h3 className='text-center'>Frequently Asked Questions About Affiliate</h3>
                            </div>
                        </div>
                        <AffiliateAccordion/>
                    </div>
                </div> */}
                {/* End Elements Area  */}

                {/* Start Elements Call To Action Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <AffiliateCallToAction />
                    </div>
                </div>
                {/* End Elements Area  */}


                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Community
